import React, { useMemo } from "react";
import { Button, Tree } from "antd";
import { isEmpty } from "lodash";

const sortByName = (nodes = []) =>
  [...nodes].sort((a, b) => (a.name || "").localeCompare(b.name || ""));

const toTreeData = (nodes = []) =>
  sortByName(nodes).map(node => ({
    key: node.key,
    title: node.name,
    children: node.childs?.length ? toTreeData(node.childs) : undefined,
  }));

/**
 * Body for AntD Table's `filterDropdown` — renders a checkable Tree of the column's
 * child statuses plus a Reset button. Selection is controlled externally.
 *
 * @param {{
 *   childNodes: Array<{ key: string|number, name: string, childs?: any[] }>,
 *   value: (string|number)[],
 *   onChange: (keys: (string|number)[]) => void,
 * }} props
 */
const StatusColumnFilter = ({ childNodes = [], value = [], onChange }) => {
  const treeData = useMemo(() => toTreeData(childNodes), [childNodes]);
  const hasSelection = value?.length > 0;

  return (
    <div className="w-72 p-2">
      {isEmpty(treeData) ? (
        <div className="text-sm text-gray-500 py-4 text-center">No child statuses</div>
      ) : (
        <div className="max-h-72 overflow-y-auto">
          <Tree
            checkable
            selectable={false}
            checkedKeys={value}
            onCheck={keys => onChange?.(keys)}
            treeData={treeData}
          />
        </div>
      )}
      <div className="flex items-center justify-end pt-2 border-t border-gray-200 mt-2">
        <Button size="small" onClick={() => onChange?.([])} disabled={!hasSelection}>
          Reset
        </Button>
      </div>
    </div>
  );
};

export default StatusColumnFilter;
